import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { displayToast } from '../../../_shared/components';

export const LoginError: React.FC = () => {
   useEffect(() => {
      displayToast(
         'error',
         'Login Error',
         'The email address provided is already registered. Please use the SSO provider originally used to sign-in.',
      );
   }, []);
   return <Redirect to={'/login'} />;
};

export const LoginExpired: React.FC = () => {
   useEffect(() => {
      displayToast('error', 'Login Expired', 'The login session has expired. Please login again.');
   }, []);
   return <Redirect to={'/login'} />;
};
